import Material from 'models/Material';

export default function traduzirCodigoMaterial(
  obj: Material,
  limitado = false,
): string {
  return `${obj.codigoSap ?? obj.diteCodigo ?? ''}`;
  // return `${obj.codigoSap ?? ''} - ${obj.descricao ?? ''}`;
}
